import { PeopleFilter, getServiceAsync } from '../../../service';
import {
    ContactFoldersData,
    runOwsRequestWithMonitor,
    Feature,
    fullResponseOperationOption,
} from '../../../shared';
import { convertFiltersToFolderData } from './converters/peopleFiltersConverter';

export default function getContactFolders(): Promise<ContactFoldersData> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'GetContactFolders',
            feature: Feature.ContactManagement,
            operation: () =>
                service.Operation.getPeopleFiltersOperation(fullResponseOperationOption),
            transformResponse: (peopleFilters: PeopleFilter[]) =>
                convertFiltersToFolderData(peopleFilters),
        })
    );
}
